'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TreeItem = require('@material-ui/lab/TreeItem');

var _TreeItem2 = _interopRequireDefault(_TreeItem);

var _Tooltip = require('../../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _styles = require('../../styles');

var _styles2 = _interopRequireDefault(_styles);

var _tokens = require('../../styles/tokens');

var _useTextOverflow3 = require('./useTextOverflow');

var _useTextOverflow4 = _interopRequireDefault(_useTextOverflow3);

var _MasterDetail = require('../MasterDetail');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = function styles(theme) {
    return {
        root: {
            '&:focus > $content $label': {
                backgroundColor: 'unset'
            },
            '&$selected > $content $label': {
                backgroundColor: 'unset'
            },
            '&$selected > $content $label:hover, &$selected:focus > $content $label': {
                backgroundColor: 'unset'
            },
            '&:focus > div': {
                backgroundColor: theme.palette.grey[250],
                boxShadow: _tokens.boxShadowFocusInset
            },
            '&$selected': {
                backgroundColor: 'unset'
            },
            '& > $content:hover, &$selected > $content:hover, &$selected:focus > $content': {
                backgroundColor: theme.palette.grey[250]
            }
        },
        expanded: {},
        selected: {},
        group: {},
        content: {},
        iconContainer: {
            marginRight: _tokens.spacing40,
            marginLeft: '-' + _tokens.spacing10,
            width: '0.125rem' // Don't have size token for 2px
        },
        label: {
            padding: _tokens.spacing30,
            paddingLeft: 0,
            '&:hover': {
                backgroundColor: theme.palette.grey[250]
            }
        }
    };
};

// TreeItem code @material-ui/lab@4.0.0-alpha.46:
// https://github.com/mui-org/material-ui/blob/v4.9.6/packages/material-ui-lab/src/TreeItem/TreeItem.js
var TreeItem = function TreeItem(props) {
    var treeItemRef = (0, _react.useRef)(null);

    var _useTextOverflow = (0, _useTextOverflow4.default)(treeItemRef, '.' + _MasterDetail.NODE_LABEL_CLASS),
        _useTextOverflow2 = _slicedToArray(_useTextOverflow, 1),
        overflow = _useTextOverflow2[0];

    var label = props.label,
        tooltipText = props.tooltipText,
        rest = _objectWithoutProperties(props, ['label', 'tooltipText']);

    var newLabel = _react2.default.createElement(
        _react2.default.Fragment,
        null,
        overflow ? _react2.default.createElement(
            _Tooltip2.default,
            { title: tooltipText },
            label
        ) : label
    );

    return _react2.default.createElement(_TreeItem2.default, Object.assign({ ref: treeItemRef, label: newLabel }, rest));
};

TreeItem.propTypes = {
    /**
     * The content of the component.
     */
    children: _propTypes2.default.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * The icon used to collapse the node.
     */
    collapseIcon: _propTypes2.default.node,
    /**
     * The icon displayed next to a end node.
     */
    endIcon: _propTypes2.default.node,
    /**
     * The icon used to expand the node.
     */
    expandIcon: _propTypes2.default.node,
    /**
     * The icon to display next to the tree node's label.
     */
    icon: _propTypes2.default.node,
    /**
     * The tree node label.
     */
    label: _propTypes2.default.node,
    /**
     * The id of the node.
     */
    nodeId: _propTypes2.default.string.isRequired,
    /**
     * @ignore
     */
    onClick: _propTypes2.default.func,
    /**
     * @ignore
     */
    onFocus: _propTypes2.default.func,
    /**
     * @ignore
     */
    onKeyDown: _propTypes2.default.func,
    /**
     * @ignore
     */
    onMouseDown: _propTypes2.default.func,
    /**
     * The component used for the transition.
     */
    TransitionComponent: _propTypes2.default.elementType,
    /**
     * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
     */
    TransitionProps: _propTypes2.default.object,
    /**
     * @ignore
     */
    tooltipText: _propTypes2.default.string
};

TreeItem.muiName = 'TreeItem';
TreeItem.displayName = 'TreeItem';

exports.default = (0, _styles2.default)(styles)(TreeItem);